<template>
    <CRow>
        <CCol col="12">
            <CCard>
                <CCardHeader>
                    <strong>Адреса Москва-Сити</strong>
                </CCardHeader>

                <CCardBody>
                    <table class="table">
                        <thead>
                            <th>Откуда</th>
                            <th>Адрес</th>
                        </thead>
                        <tbody>
                            <tr v-for="item in list" :key="item.id">
                                <td>
                                    <CLink
                                        class="text-purple-700 cursor-pointer hover:underline"
                                        :to="`/tower-time/${item.id}`"
                                    >{{ item.name }}</CLink>
                                </td>
                                <td>
                                    {{ item.address }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>
<script>
    export default {
        name: 'TowerTime',

        data: () => ({
            list: [],
        }),

        computed: {},

        mounted() {
            this.updateData();
        },

        methods: {
            async updateData() {
                try {
                    const { data } = await this.axios.get('/address');
                    this.list = data;
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                }
            },
        },
    };
</script>
